import { render, staticRenderFns } from "./BusquedaArticuloComponent.vue?vue&type=template&id=e507c244"
import script from "./BusquedaArticuloComponent.vue?vue&type=script&lang=js"
export * from "./BusquedaArticuloComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports